// extracted by mini-css-extract-plugin
module.exports = {"container":"container--2Dvz5","group":"group--1IDEH"};